
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "ui-audio-control"
})
export default class UiAudioControlComponent extends Vue {
  @Prop({ default: false })
  src!: string | Blob;
  @Prop()
  name!: string;
  isPlay: boolean = false;
  duration: number = 0;
  currentTime: number = 0;
  temp: number = 0;
  @Watch('src')
  onSrcChanged() {
    this.stopWatch();
    this.isPlay = false;
    this.currentTime = 0;
    this.duration = 0;
    this.$nextTick(() => this.audioEl && this.audioEl.load());
  }
  get percentCompelete(): number {
    if (!this.currentTime || !this.duration) {
      return 0;
    }
    return (this.currentTime / this.duration)*100;
  }
  setCurrentTime(value : number) {
    this.audioEl.currentTime = value;
    this.currentTime = value;
  }
  get durationDisplay(): string {
    if (!this.duration) {
      return '00:00';
    }
    const minutes = Math.floor(this.duration / 60);
    const seconds = Math.floor(this.duration % 60);
    const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const displaySeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${displayMinutes}:${displaySeconds}`;
  }
  timeout: NodeJS.Timeout;
  get audioEl(): HTMLAudioElement {
    return this.$refs.audioEl as HTMLAudioElement;
  }
  onChangeTrack(e: Event) {
    var trg = e.target as HTMLInputElement;
    this.setCurrentTime(Number(trg.value));
  }
  playStop() {
    if (this.isPlay) {
      this.audioEl.pause();
      this.stopWatch();
      return;
    }

    const playPromise = this.audioEl.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(() => {
          this.isPlay = true;
          this.startWatch();
        })
        .catch(() => {
          this.isPlay = false;
          this.stopWatch();
        });
      return;
    }

    this.isPlay = true;
    this.startWatch();
  }
  beforeDestroy() {
    this.stopWatch();
  }
  stopWatch() {
    this.timeout && clearInterval(this.timeout);
    this.timeout = null;
  }
  startWatch() {
    if(this.timeout) {
      return;
    }
    this.timeout = setInterval(this.refreshTime, 1000);
  }
  refreshTime() {
    this.currentTime = this.audioEl.currentTime;
  }
  loadedmetadata(e: Event) {
    const d = this.audioEl;
    this.duration = (e.target as HTMLMediaElement).duration;
  }
  onPause(e: any) {
    this.isPlay = false;    
    this.stopWatch();
  }
  onEnd() {
    this.isPlay = false;
    this.stopWatch();
  }
  onStart() {
    this.isPlay = true;
    this.startWatch();
  }
  onError() {
    this.isPlay = false;
    this.stopWatch();
  }
}
